import { FC, SVGProps } from "react";

const DefaultCheckIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg fill="none" stroke="currentcolor" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" {...props}>
      <path d="M7 13l3 3L17 9" />
    </svg>
  );
};

export default DefaultCheckIcon;
